import React from 'react'

import { PhotoThumbnail } from '../PhotoThumbnail'
import * as S from './PhotoTableCellContent.styled'
import type { PhotoTableCellContentProps } from './types'

export const PhotoTableCellContent = ({
  name,
  description,
  photo,
  photoSize,
}: PhotoTableCellContentProps) => (
  <S.Container>
    <S.ImageContainer>
      <PhotoThumbnail url={photo} size={photoSize} />
    </S.ImageContainer>
    <S.NameContainer>
      <S.Name>{name}</S.Name>
      {description && <S.Description>{description}</S.Description>}
    </S.NameContainer>
  </S.Container>
)
